import { useMemo } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';

import AppBarStyled from './AppBarStyled';
import HeaderContent from './HeaderContent';
import IconButton from '@mui/material/IconButton';
import Logo from 'components/logo';

import useConfig from 'hooks/useConfig';
import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';
import { MenuOrientation, DRAWER_WIDTH, MINI_DRAWER_WIDTH, DRAWER_COLLAPSE_BREAKPOINT } from 'config';
import { circularIconHoverSx } from '@/styles/iconHover';

import MenuFoldOutlined from '@ant-design/icons/MenuFoldOutlined';
import MenuUnfoldOutlined from '@ant-design/icons/MenuUnfoldOutlined';

export default function Header() {
  const downLG = useMediaQuery((theme) => theme.breakpoints.down(DRAWER_COLLAPSE_BREAKPOINT));
  const { menuOrientation } = useConfig();
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;
  const isHorizontal = menuOrientation === MenuOrientation.HORIZONTAL && !downLG;

  const headerContent = useMemo(() => <HeaderContent />, []);

  const mainHeader = (
      <Toolbar>
        {downLG && (
            <Logo isIcon sx={{ width: 32, height: 32, mr: 1 }} />
        )}
        {!isHorizontal ? (
            <IconButton
                aria-label="open drawer"
                onClick={() => handlerDrawerOpen(!drawerOpen)}
                edge="start"
                sx={{
                  ...circularIconHoverSx({ color: 'text.primary', hoverBg: 'action.hover' }),
                  ml: downLG ? 0 : -2
                }}
            >
              {!drawerOpen ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            </IconButton>
        ) : null}
        {headerContent}
      </Toolbar>
  );

  const appBar = {
    position: 'fixed',
    color: 'inherit',
    elevation: 0,
    sx: {
      borderBottom: '1px solid',
      borderBottomColor: 'divider',
      // Forza l'header ad essere un livello sopra il drawer destro
      zIndex: (theme) => theme.zIndex.drawer + 1,
      width: isHorizontal ? '100%' : (downLG ? '100%' : 'auto'),
      left: isHorizontal ? 0 : (downLG ? 0 : drawerOpen ? `${DRAWER_WIDTH}px` : `${MINI_DRAWER_WIDTH}px`),
      right: 0 // Fissato a 0
    }
  };

  return (
      <>
        {!downLG ? (
            <AppBarStyled openLeft={drawerOpen} {...appBar}>
              {mainHeader}
            </AppBarStyled>
        ) : (
            <AppBar {...appBar}>{mainHeader}</AppBar>
        )}
      </>
  );
}